import React from 'react';
import { Button, Card, DatePicker, Form, message, Spin, Select, Input, Icon, Cascader, Tooltip } from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import { fetchEvt } from "../../redux/actions/evt";
import lodash from "lodash"
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import { patchEventConfig } from "../../services/evt";
import PurchaseServiceTips from "../PurchaseServiceTips";
import { isValidity } from "../../services/global";
import { deepClone } from "../../utils/index";
import moment from 'moment';
import City from "../../components/City";

let City2= deepClone(City,[])
City2.forEach(p=>{
    if(p.hasOwnProperty('children')){
        p.children.forEach(c=>delete c.children)
    }
})

const RangePicker = DatePicker.RangePicker;

const mapStateToPorps = state => {
    const loginedUser = state.loginedUser;
    const cmEnums = state.cmEnums;
    return { cmEnums, loginedUser };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewSignUpAddress extends React.Component {
    constructor(props) {
        super(props);
        this.pstView = null;
        console.log(props)
        this.state = {
            validity: false,
            formLoading: false,

        }
    }
    componentDidMount() {


        isValidity('SENIORMEMBER', (vaild) => {
            this.setState({
                validity: vaild
            })
        })

    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true)
                console.log(values)
                values.allowSignUpCityList ? null : values.allowSignUpCityList = [];
                values.allowSignUpCityList = values.allowSignUpCityList.map(obj=>({province:obj[0],city:obj[1]}))
                patchEventConfig(Object.assign({ id: this.props.evt.header.id }, values)).then(res => {
                    console.log("updateEventConfig res: ", res);
                    if (res.code == 200) {
                        message.info("更新成功!");
                        this.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }
    addField = (fieldName, value = {}) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        var _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        _fieldVal.push(value);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);


        form.setFieldsValue(fieldsValue);
    }


    removeField = (fieldName, index) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        let fieldVal = lodash.get(fieldsValue, fieldName);
        let _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);
        lodash.set(fieldsValue, fieldName, fieldVal);

        form.setFieldsValue(fieldsValue);

    }

    render() {
        const evt = this.props.evt;
     
        const { getFieldDecorator, getFieldValue, getFieldsValue, getFieldError, setFieldsValue } = this.props.form;
        getFieldDecorator('_allowSignUpCityList', { initialValue: evt.config.allowSignUpCityList ? evt.config.allowSignUpCityList : [] });
        const allowSignUpCityList = getFieldValue('_allowSignUpCityList') ? getFieldValue('_allowSignUpCityList') : [];

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={()=>{
                    this.state.validity ? this.save() : this.pstView.show()
                }}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={() => {
                this.intoEdit()
            }}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>

        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{ padding: "16px" }}>
                        {editableTools}
                        <div style={{color:'#9e9e9e',marginBottom:8}}>
                            指定报名城市 &nbsp;

                              <Tooltip placement="bottom" overlayClassName='overlay-image'
                                mouseEnterDelay={0.3} title={
                                    <div>
                                        可指定仅某个或多个城市的参与人，才能报名该活动
                                    </div>
                                }>
                                <Icon type="question-circle-o" />
                            </Tooltip>
                        </div>
                    
                        {
                            this.props.editable ?
                                allowSignUpCityList.map((obj, index) => (
                                    <CkInfoItem key={index} labelStyle={{ display: 'none' }}>
                                        <div style={{ width: '50%', }}>
                                            {getFieldDecorator(`allowSignUpCityList[${index}]`, {
                                                initialValue: obj ? [obj.province,obj.city] : [],
                                                rules: [
                                                    { required: true, message: '请选择!', },

                                                ],
                                            })(
                                                <Cascader placeholder={"请选择"} options={City2} style={{ width: '80%' }} />
                                            )}
                                            <Icon
                                                className="dynamic-delete-button"
                                                type="minus-circle-o"
                                                onClick={() => this.removeField('allowSignUpCityList', index)}
                                            />
                                        </div>
                                    </CkInfoItem>
                                ))
                                :
                                ''
                        }
                        {
                            this.props.editable ?
                                <CkInfoItem labelStyle={{ display: 'none' }}>
                                    <div style={{ width: '50%', }}>
                                        <Button type="dashed" onClick={() => this.addField('allowSignUpCityList', '')} style={{ width: 150, }}>
                                            <Icon type="plus" /> 添加城市
                                                </Button>
                                    </div>
                                </CkInfoItem>
                                :
                                <div style={{paddingLeft:8}}>
                                    {
                                        evt.config.allowSignUpCityList ? '已设置' : "未设置"
                                    }
                                </div>
                        }




                    </Card>
                </Spin>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}
                />
            </Form>
        )
    }
}


EvtViewSignUpAddress.contextTypes = {}

EvtViewSignUpAddress.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "signUpAddress",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewSignUpAddress.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewSignUpAddress));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewSignUpAddress.jsx